module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@10.0.2__encoding@0.1.13_react-dom@19.2.4_react_47f6190ddbf6bf3e5171ee510da81b2d/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
